
const Icon = ({ name }) => {
  return (
    <span className='material-symbols-rounded'>
      {name}
    </span>
  );
};

export default Icon;